import React from "react";
import authRoute from "./authRoute";
import appsRoute from "./appsRoute";

export const publicRoutes = [
  ...authRoute,
  {
    key: "Dashboard",
    path: "/",
    component: React.lazy(() => import("views/crm/Dashboard/Dashboard.js")),
    authority: ['player', 'Administrator'],
  },
  {
    key: "AllGolfCourses",
    path: "Golf-Courses",
    component: React.lazy(() => import("views/crm/Dashboard/AllGolfCourses.js")),
    authority: ['player', 'Administrator'],
  },
  {
    key: "GolfCourse",
    path: "GolfCourse",
    component: React.lazy(() => import("views/crm/GolfCourse/")),
    authority: ['player', 'Administrator'],
  },
  {
    key: "TeeTimeBooking",
    path: "TeeTimeBooking/:id",
    component: React.lazy(() => import("views/crm/TeeTimeBooking/")),
    authority: ['player', 'Administrator'],
  },
  {
    key: "TeeTimeBookingFlow",
    path: "TeeTimeBooking/book/:teeTimeId",
    component: React.lazy(() => import("views/crm/TeeTimeBooking/TeeTimeBookingPage/")),
    authority: ['player', 'Administrator'],
  },
  {
    key: "Individual",
    path: "golf-course/:id",
    component: React.lazy(() => import("views/crm/GolfCourse/IndividualGolf.js")),
    authority: ['player', 'Administrator',"Admin","Company Admin"],
  },

];
export const protectedRoutes = [
  ...appsRoute,
  {
    key: "home",
    path: "/home",
    component: React.lazy(() => import("views/crm/Home/Home.js")),
    authority: ['Company Admin', 'Administrator'],
  },
  {
    key: "history",
    path: "/teetimebookinghistory",
    component: React.lazy(() => import("views/crm/TeeTimeBooking/TeeTimeBookingHistory/index.js")),
    authority: ['player', 'Administrator'],
  },
  {
    key: "players",
    path: "/players",
    component: React.lazy(() => import("views/crm/Players/")),
    authority: ['Company Admin', 'Administrator'],
  },
  {
    key: "PlayerDetails",
    path: "/players/:playerId",
    component: React.lazy(() => import("views/crm/Players/PlayerDetails.js")),
    authority: ['Company Admin', 'Administrator'],
  },
  {
    key: "ProfileSettings",
    path: "/profile-settings",
    component: React.lazy(() => import("views/crm/ProfileSettings/")),
    authority: ['player', 'Company Admin', 'Administrator'],
  },
  {
    key: "accessdenied",
    path: "/access-denied",
    component: React.lazy(() => import("views/auth/AccessDenied")),
    authority: [],
  },
  {
    key: "Profile",
    path: "Profile",
    component: React.lazy(() => import("views/crm/Profile/")),
    authority: ['Company Admin', 'Administrator'],
  },
  {
    key: "Reservations",
    path: "Reservations",
    component: React.lazy(() => import("views/crm/TeeTimeBooking/components/Reservation.js")),
    authority: ['player', 'Administrator'],
  },
  {
    key: "Membership",
    path: "Membership",
    component: React.lazy(() => import("views/crm/Profile/Components/Memberships.js")),
    authority: ['player', 'Company Admin', 'Administrator'],
  },
  {
    key: "CreateTeeTime",
    path: "CreateTeeTime",
    component: React.lazy(() => import("views/crm/CreateTeeTime/")),
    authority: ['Company Admin', 'Administrator'],
  },
  {
    key: "PurchaseProducts",
    path: "PurchaseProducts",
    component: React.lazy(() => import("views/crm/PlayerProducts/ProductList.js")),
    authority: ['player', 'Company Admin', 'Administrator'],
  },
  {
    key: "CheckoutList",
    path: "CheckoutList",
    component: React.lazy(() => import("views/crm/CreateTeeTime/components/CheckoutList.js")),
    authority: ['Company Admin', 'Administrator'],
  },
  // {
  //   key: "Products",
  //   path: "Products",
  //   component: React.lazy(() => import("views/crm/Products/")),
  //   authority: ['Company Admin', 'Administrator'],
  // },
  {
    key: "Pricing",
    path: "Pricing",
    component: React.lazy(() => import("views/crm/PricingAndMemberships/index.js")),
    authority: ['Company Admin', 'Administrator'],
  },
  // {
  //   key: "Tournament",
  //   path: "Tournament",
  //   component: React.lazy(() => import("views/crm/Tournaments/Tournament.js")),
  //   authority: ['Company Admin', 'Administrator'],
  // },
  {
    key: "TeeTimeHistoryDetails",
    path: "TeeTimeHistoryDetails/:bookingId",
    component: React.lazy(() => import("views/crm/TeeTimeBooking/TeeTimeBookingHistory/TeeTimeHistoryDetails.js")),
    authority: ['Company Admin', 'Administrator', 'player'],
  },
  {
    key: "PaymentCollection",
    path: "PaymentCollection/:bookingId",
    component: React.lazy(() => import("views/crm/TeeTimeBooking/TeeTimeBookingHistory/PaymentCollection.js")),
    authority: [ 'player'],
  },
  // {
  //   key: "Membership Configuration",
  //   path: "membership-configuration",
  //   component: React.lazy(() => import("views/crm/MembershipConfig/index.js")),
  //   authority: ['Company Admin', 'Administrator'],
  // },
  {
    key: "GolfBookings",
    path: "GolfBookings",
    component: React.lazy(() => import("views/crm/Bookings/index.js")),
    authority: ['Company Admin'],
  },
];

